export const BS_FINANCE_RESET_STATE = "bsFinanceResetState"
export const SET_BS_FINANCES = "setBSFinances"
export const SET_BS_FINANCE = "setBSFinance"
export const SET_BS_FINANCE_PAGINATION = "setBSFinancePagination"
